import { useState } from "react";

export const usePagination = <Type>(
  allItems: Type[],
  perPage: number,
  firstLoad?: number
): [Type[], () => void, () => void] => {
  const [showedItems, setShowedItems] = useState(firstLoad || perPage);
  const loadMore = () => setShowedItems(showedItems + perPage);
  const reset = () => setShowedItems(firstLoad || perPage);

  const items = allItems?.slice(0, showedItems);

  return [items, loadMore, reset];
};
